import React from "react";
import { Link } from "gatsby";

const DisclaimerCopy = () => (
    <div className="paragraph-3 lh-base">
        I understand that by providing my number here, I am agreeing to receive
        promotional and other informational text messages from ShiftMed. Reply
        HELP for questions and assistance, or STOP to unsubscribe. Message
        frequency varies. Message and data rates may apply. View our{" "}
        <Link to="/terms/" target="privacy">
            Terms & Conditions
        </Link>{" "}
        or{" "}
        <Link to="/privacy/" target="privacy">
            Privacy Policy
        </Link>{" "}
        here
    </div>
);

export default DisclaimerCopy;
